import type { SVGProps } from 'react';

const SvgAnnotationEraser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15 19h-1.59l6.7-6.7c.57-.57.88-1.32.88-2.12s-.31-1.56-.88-2.12l-3.17-3.17c-1.13-1.13-3.11-1.13-4.24 0l-8.66 8.66a3 3 0 0 0 0 4.24l2.62 2.62c.38.38.88.59 1.41.59H15c.55 0 1-.45 1-1s-.45-1-1-1M12 8.41 16.59 13 14 15.59 9.41 11zM14.83 6c.27 0 .52.1.71.29l3.17 3.17c.19.19.29.44.29.71s-.1.52-.29.71l-.71.71L13.41 7l.71-.71a1 1 0 0 1 .71-.29M5.45 16.38a.996.996 0 0 1 0-1.41L8 12.42l4.59 4.59-2 2H8.08zM20 19h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgAnnotationEraser;
